import Vue from 'vue'
import VueRouter from 'vue-router'
import {getStorageInfo, getToken} from "../common/js/storage";
import store from "../store/index";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {getUserRouterMenus} from "../permission/module";
// import RouteView from "../layouts/RouteView";

export const base = process.env.NODE_ENV === 'production' ? "": "";

Vue.use(VueRouter);

const defaultRoutePath  = "/dashboard";

const notFoundRouter = {
  path: '*',
  name: 'NotFound',
  component: () => import(/* webpackChunkName: "404" */ '../views/NotFound.vue')
}


const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      open: true,
      title: '登录'
    }
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: () => import(/* webpackChunkName: "404" */ '../views/Forbidden.vue'),
    meta: {
      open: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start();
  const token = getToken();
  if (token) {
    store.commit("setLogin", true);
    const meta = to.meta;
    //页面标题
    const title = meta.title;
    if (title) {
      document.title = title;
    }
    const registered = store.getters.registered;
    if(!registered) {
      const user = getStorageInfo();
      let [routers, defaultPath] = getUserRouterMenus(user);
      if(routers) {
        routers.forEach(r => {
          router.addRoute(r);
        })
      }
      router.addRoute(notFoundRouter);
      store.commit("changeRegistered", true);
      // 已经登录或者根路由则直接跳转
      if(to.path === '/') {
        let path = to.query.r || defaultPath || defaultRoutePath;
        next({path, replace: true});
      } else {
        next({...to});
      }
    } else {
      if(to.path === '/') {
        let defaultPath = store.getters.defaultPath;
        let path = to.query.r || defaultPath || defaultRoutePath;
        next({path, replace: true});
      } else {
        next();
      }
    }
  } else if(to.meta.open) {
    next();
  } else {
    next({name: 'Login', query: {r: to.path}});
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router
